import ListTemplate from '../../html/components/list.html'
import ListItemTemplate from '../../html/components/list-item.html'
import ListCellTemplate from '../../html/components/list-cell.html'

import Component from '../shared/component'
import Relation, {HasMany, MemberOf} from '../shared/mixins/relation'

import {InteractiveMixin} from './interactive'
import {CollapseToggleMixin} from './collapse'

const listItems = Relation()

export const List = Component('v-list', {
  mixins: [
    HasMany(listItems, 'items'),
    MemberOf(listItems, 'list')
  ],
  template: ListTemplate,
  props: {
    indent: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    classes () {
      const {list} = this

      return {
        'is-nested': list !== null,
        'is-indented': list !== null && this.indent,
        'is-first': list && list.first === this,
        'is-last': list && list.last === this
      }
    },

    first () {
      const {items} = this

      if (items.length !== 0) {
        return items[0]
      }
    },

    last () {
      const {items} = this

      for (let i = items.length - 1; i >= 0; i--) {
        const item = items[i]
        const prev = items[i - 1]

        if (prev && prev.expanded === false) {
          continue
        }

        return item
      }
    }
  }
})

export const ListItem = Component('v-list-item', {
  mixins: [
    MemberOf(listItems, 'list'),
    InteractiveMixin,
    CollapseToggleMixin
  ],
  template: ListItemTemplate,
  props: {
    active: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    classes () {
      const {list} = this

      return {
        'is-active': this.active || this.expanded,
        'has-interactive': this.interactive,
        'is-first': list && list.first === this,
        'is-last': list && list.last === this
      }
    },

    expanded () {
      const {collapse, $attrs} = this

      if (collapse) {
        return collapse.active
      }

      if ($attrs) {
        return $attrs['aria-expanded']
      }
    },

    controls () {
      const {collapse, $attrs} = this

      if (collapse) {
        return collapse.target
      }

      if ($attrs) {
        return $attrs['aria-controls']
      }
    }
  }
})

export const ListCell = Component('v-list-cell', {
  template: ListCellTemplate,
  props: {
    fill: {
      type: Boolean,
      default: false
    },
    align: {
      type: String,
      default: null,
      validator (value) {
        switch (value) {
          case '':
          case 'top':
          case 'bottom':
            return true
          default:
            return false
        }
      }
    }
  },
  computed: {
    classes () {
      return {
        'is-fill': this.fill,
        [`is-${this.align}`]: this.align
      }
    }
  }
})
